<template>
  <header class="app-header">
    <div class="brand" @click="goHome">
      <img class="brand-logo" :src="logoUrl" alt="蔡蔡纸样" />
      <span class="brand-text">蔡蔡纸样</span>
    </div>
    <el-menu
      :key="route.path"
      class="header-menu header-menu--desktop"
      mode="horizontal"
      :ellipsis="false"
      :router="true"
      :default-active="activePath"
    >
      <el-menu-item index="/app/ops-dashboard">运营看板</el-menu-item>
      <el-menu-item index="/app/home">款式列表</el-menu-item>
      <el-menu-item index="/app/preview-styles">预告款列表</el-menu-item>
      <el-menu-item index="/app/customers">客户列表</el-menu-item>
      <el-menu-item index="/app/work-review">作业审核</el-menu-item>
      <el-menu-item index="/app/preview-style-review">预告款审核/试板</el-menu-item>
      <el-menu-item index="/app/orders">订单列表</el-menu-item>
      <el-menu-item index="/app/refund-review">退款审核</el-menu-item>
      <el-menu-item index="/app/dicts">字典</el-menu-item>
      <el-menu-item index="/app/plt-converter">PLT转PDF</el-menu-item>
    </el-menu>
    <div class="header-actions">
      <el-button class="menu-toggle" link type="primary" aria-label="打开菜单" @click="drawerVisible = true">
        <el-icon :size="22"><Menu /></el-icon>
      </el-button>
      <el-button class="logout-btn" link type="danger" @click="logout">退出登录</el-button>
    </div>

    <el-drawer
      v-model="drawerVisible"
      class="mobile-nav-drawer"
      direction="rtl"
      size="min(280px, 78vw)"
      append-to-body
      :with-header="false"
    >
      <div class="drawer-brand">蔡蔡纸样</div>
      <el-menu
        class="drawer-menu"
        mode="vertical"
        :router="true"
        :default-active="activePath"
        @select="drawerVisible = false"
      >
        <el-menu-item index="/app/ops-dashboard">运营看板</el-menu-item>
        <el-menu-item index="/app/home">款式列表</el-menu-item>
        <el-menu-item index="/app/preview-styles">预告款列表</el-menu-item>
        <el-menu-item index="/app/customers">客户列表</el-menu-item>
        <el-menu-item index="/app/work-review">作业审核</el-menu-item>
        <el-menu-item index="/app/preview-style-review">预告款审核/试板</el-menu-item>
        <el-menu-item index="/app/orders">订单列表</el-menu-item>
        <el-menu-item index="/app/refund-review">退款审核</el-menu-item>
        <el-menu-item index="/app/dicts">字典</el-menu-item>
        <el-menu-item index="/app/plt-converter">PLT转PDF</el-menu-item>
      </el-menu>
      <el-button class="drawer-logout" type="danger" plain @click="logoutFromDrawer">退出登录</el-button>
    </el-drawer>
  </header>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Menu } from '@element-plus/icons-vue'
import logoUrl from '@/assets/suzy-logo.jpg'
import { clearAuth } from '@/utils/auth'

const route = useRoute()
const router = useRouter()
const drawerVisible = ref(false)

/** 与当前路由匹配的菜单高亮 */
const activePath = computed(() => {
  if (route.path.startsWith('/app/ops-dashboard')) return '/app/ops-dashboard'
  if (route.path.startsWith('/app/style/')) return '/app/home'
  if (route.path.startsWith('/app/preview-style-review')) return '/app/preview-style-review'
  if (route.path.startsWith('/app/preview-style')) return '/app/preview-styles'
  if (route.path.startsWith('/app/work-review')) return '/app/work-review'
  if (route.path.startsWith('/app/refund-review')) return '/app/refund-review'
  if (route.path.startsWith('/app/orders')) return '/app/orders'
  if (route.path.startsWith('/app/dicts')) return '/app/dicts'
  if (route.path.startsWith('/app/plt-converter')) return '/app/plt-converter'
  if (route.path.startsWith('/app/customers')) return '/app/customers'
  if (route.path.startsWith('/app/home')) return '/app/home'
  return route.path
})

function goHome() {
  router.push({ name: 'home' })
}

function logout() {
  clearAuth()
  router.replace({ name: 'login' })
}

function logoutFromDrawer() {
  drawerVisible.value = false
  logout()
}
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 56px;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  white-space: nowrap;
  margin-right: 12px;
  flex-shrink: 0;
  min-width: 0;
}

.brand-logo {
  height: 36px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
  display: block;
}

.brand-text {
  font-size: 18px;
  font-weight: 600;
  color: #409eff;
}

.header-menu {
  flex: 1;
  border-bottom: none;
  min-width: 0;
}

.header-menu :deep(.el-menu-item) {
  font-size: 15px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.menu-toggle {
  display: none;
  padding: 8px;
}

.drawer-brand {
  padding: 8px 4px 16px;
  font-size: 18px;
  font-weight: 600;
  color: #409eff;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 8px;
}

.drawer-menu {
  border-right: none;
}

.drawer-logout {
  width: 100%;
  margin-top: 16px;
}

@media (max-width: 768px) {
  .app-header {
    padding: 0 12px;
    gap: 4px;
  }

  .brand-text {
    font-size: 16px;
  }

  .brand-logo {
    height: 32px;
    max-width: 120px;
  }

  .header-menu--desktop {
    display: none;
  }

  .menu-toggle {
    display: inline-flex;
  }

  .logout-btn {
    padding: 8px 4px;
    font-size: 13px;
  }
}
</style>
